import Cookies from "js-cookie";

export async function verificarCupomOld(cupom){
    try {
        cupom = cupom.replace(" ", "");
        const resposta = await (await fetch(`https://www.nugali.com.br/adm7541/cupons/?cupom=${cupom}`, {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            }
        })).json();
        if (resposta.status === "404") return { valido: false, mensagem: "Cupom não encontrado!" };
        else if (resposta.payment_status !== "approved") return { valido: false, mensagem: "Cupom inválido!" };
        else if (resposta.used) return { valido: false, mensagem: "Cupom já utilizado!" };
        const respostaConsumir = await (await fetch(`https://www.nugali.com.br/adm7541/cupons/?cupom=${cupom}&action=take`, {
            method: "put",
            headers: {
                "Content-Type": "application/json"
            }
        })).json();
        console.log(respostaConsumir)
        return { valido: true, mensagem: "Cupom utilizado com sucesso!" }
    } catch (e) {
        console.log(e.message);
        return { valido: false, mensagem: e.message };
    }
}

// Função responsável por verificar um cupom e já marcar como utilizado caso seja válido
export async function verificarCupom(codigo){
    try {
        // Remove possíveis espaços
        codigo = codigo.replace(" ", "");

        // Envia requisição ao servidor para consultar codigo
        const resposta = await (await fetch(`/api/cupons/${codigo}`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        })).json();

        // Verifica se retornou status de não encontrado
        if (resposta.status === 404) return { valido: false, mensagem: "Cupom não encontrado." };

        // Verifica se retornou algum cupom
        if (resposta.length < 1) return { valido: false, mensagem: "Cupom não encontrado." };

        // Atribui o cupom de acordo com o retorno
        const cupom = resposta[0];

        // Verifica se o cupom foi cancelado
        if (cupom.cancelado) return { valido: false, mensagem: "Cupom inválido: " + cupom.motivoCancelamento };

        // Verifica se o cupom já foi utilizado
        if (cupom.jaUtilizado) return { valido: false, mensagem: "Este cupom já foi utilizado." };

        // Envia requisição ao servidor para marcar cupom como utilizado
        const respostaUtilizacao = await (await fetch(`/api/cupons/utilizar/${codigo}`, {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        })).json();

        console.log(respostaUtilizacao);

        // Verifica se a utilização retorno sucesso
        if (respostaUtilizacao.status === 200) {
            return { valido: true, mensagem: "Cupom utilizado com sucesso!" };
        } else {
            return { valido: false, mensagem: respostaUtilizacao.mensagem };
        }

    } catch (e) {
        console.log(e.message);
        return { valido: false, mensagem: e.message };
    }
}

// Função para obter listagem de cupons
export async function obterCupons(pagina, ordenacao, ordem, busca, dataI, dataF, origem){
    try {
        let params = `?pagina=${pagina}&ordenacao=${ordenacao}&ordem=${ordem}`;
        if (busca) params += `&busca=${busca}`;
        if (dataI) params += `&dataInicial=${dataI}`;
        if (dataF) params += `&dataFinal=${dataF}`;
        if (origem) params += `&origem=${origem}`;

        // Envia requisição ao servidor
        const resposta = await (await fetch(`/api/cupons${params}`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        })).json();

        // Retorna os cupons obtidos
        return resposta;
    } catch (e) {
        console.log(e.message);
        return [];
    }
}

// Função para criar novos cupons
export async function criarCupons(quantidade, nome, email, celular){
    try {
        // Envia requisição ao servidor para consultar codigo
        const resposta = await (await fetch("/api/cupons/", {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            },
            body: JSON.stringify({
                quantidade: quantidade,
                visitante: {
                    nome: nome,
                    email: email,
                    celular: celular
                },
                origem: "tour",
                pagamentoEfetivado: true
            })
        })).json();

        if (resposta.status === 201) return true;
    } catch (e) {
        console.log(e.message);
        return false;
    }
}

// Função para obter um cupom a partir de seu id
export async function obterCupomPorId(id) {
    try {
        // Envia requisição ao servidor
        const resposta = await (await fetch(`/api/cupons/id/${id}`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        })).json();

        if (resposta.status === 200) return resposta.cupom;
        else return null;
    } catch (e) {
        console.log(e.message);
        return null;
    }
}

// Função para marcar um cupom como utilizado
export async function marcarCupomUtilizado(cupom) {
    try {
        const resposta = await (await fetch(`/api/cupons/utilizar/${cupom.codigo}`, {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            }
        })).json();

        if (resposta.status === 200) return true; else return false;
    } catch (e) {
        console.log(e.message);
        return false;
    }
}

// Função para cancelar um cupom
export async function cancelarCupom(cupom, motivo) {
    try {
        const resposta = await (await fetch(`/api/cupons/cancelar/${cupom.codigo}`, {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Cookies.get("token_tour")
            },
            body: JSON.stringify({
                motivoCancelamento: motivo
            })
        })).json();

        if (resposta.status === 200) return true; else return false;
    } catch (e) {
        console.log(e.message);
        return false;
    }
}